import { render, staticRenderFns } from "./crud-radio.vue?vue&type=template&id=05acc5f6&"
import script from "./crud-radio.vue?vue&type=script&lang=js&"
export * from "./crud-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports